<div [ngClass]="{ container: true, logined: logined }" cdkOverlayOrigin #containerOrigin="cdkOverlayOrigin">
  <ng-container *ngIf="logined">
    <!-- im聊天 -->
    @if (chatService.chatEnabled) {
      <div class="menu-trigger mutual-opacity imchat" (click)="closePop(); chatService.toggleChat(isH5)">
        <div class="notification">
          <i class="im-chat-icon" [class.active]="chatService.chatPop">
            <span *ngIf="chatService.unreadCount > 0" class="badge">
              {{ chatService.unreadCount > 99 ? '99+' : chatService.unreadCount }}
            </span>
          </i>
        </div>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayPanelClass]="'chat-pop-panel'"
          [cdkConnectedOverlayOrigin]="containerOrigin"
          [cdkConnectedOverlayOpen]="chatService.chatPop"
          [cdkConnectedOverlayPositions]="containerPositions"
          [cdkConnectedOverlayFlexibleDimensions]="true"
        >
          <!-- (overlayOutsideClick)="closePop(10)" -->
          <app-chat></app-chat>
        </ng-template>
      </div>
    }

    <!-- 通知 -->
    <!-- <div class="menu-trigger" (click)="notificationDialogService.openNotification(1)"> -->
    <!-- <div class="menu-trigger" (mouseenter)="showPop('notification')" (mouseleave)="closePop(150)"> -->
    <!-- <div class="notification">
        <div *ngIf="messagesCount > 0" class="notification-badge"></div>
        <i class="fi-bell-filled"> </i>
      </div> -->
    <!-- </div> -->

    <!-- 聊天室 -->
    <a [routerLink]="" class="menu-trigger" (click)="openChat()">
      <div class="chart-room">
        <i class="fi-chat-alt-2"></i>
      </div>
    </a>

    <!-- 用户账户信息 -->
    <div class="menu-trigger" (mouseenter)="showPop('user')" (mouseleave)="closePop(150)">
      <app-user-avatar
        [isActive]="popStatus.user"
        [bounsCount]="bounsCount"
        [avatarImgSrc]="userInfo?.avater || ''"
        [currentVipLevel]="currentVipLevel"
        [isSuperVip]="isSuperVip"
        [messagesCount]="messagesCount"
      />
      <ng-template
        #avater
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="containerOrigin"
        [cdkConnectedOverlayOpen]="popStatus.user"
        [cdkConnectedOverlayPositions]="containerPositions"
        [cdkConnectedOverlayFlexibleDimensions]="true"
      >
        <div class="user-center-contaienr" (mouseenter)="showPop('user', false)" (mouseleave)="closePop()">
          <app-scrollbar>
            @for (item of menuData; track $index) {
              <cs-standard-tab
                [class]="item.class || ''"
                *ngIf="(!item.showOnly || item.showOnly === 'web') && !item.showOnlyCountry"
                (click)="handleClick(item)"
                [routerLink]="!item.page ? null : item.page"
                [routerLinkActive]="!item.page ? '' : 'active'"
              >
                <div>
                  <i class="fi-{{ item.icon }}"></i>
                  <span>{{ item.title }}</span>
                </div>
                @if (item.ident === 'bonuses') {
                  <em *ngIf="bounsCount">{{ bounsCount > 99 ? '99+' : bounsCount }}</em>
                }
                @if (item.ident === 'notifications') {
                  <em *ngIf="messagesCount">{{ messagesCount > 99 ? '99+' : messagesCount }}</em>
                }
              </cs-standard-tab>
            }
          </app-scrollbar>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <ng-container *ngIf="!logined && !isSimple">
    <cs-button label="Log In" [color]="'third'" (buttonClick)="appService.jumpToLogin()"></cs-button>
    <cs-button label="Sign Up" [color]="'primary'" (buttonClick)="appService.jumpToRegister()"></cs-button>
  </ng-container>
</div>
